export const HEADER_TEXT = 'Launch Snapshot'
